<template>
    <div class="file-select">
        <div v-if="files.length" class="file-select__files">
            <div v-for="file of files">
                {{ file.name }}
            </div>
        </div>
        <button class="file-select__button"
                type="button"
                @click="onBtnClick"
        >
            <file-icon></file-icon>
            Vælg filer
        </button>
    </div>
</template>

<script>
    import $ from 'jquery';
    import FileIcon from './file-icon';

    export default {
        components: {
            'file-icon': FileIcon
        },
        props: {
            input: {
                required: true,
                type: HTMLInputElement,
            }
        },
        data() {
            return {
                files: [],
            }
        },
        mounted () {
            $(this.input).on('change', (e) => {
                this.files = Array.from(e.target.files);
            });
        },
        methods: {
            onBtnClick() {
                this.input.click();
            }
        }
    }
</script>
